import * as Chartist from 'chartist';
import tooltipPlugin from './chartist/tooltip_plugin';

tooltipPlugin.register(Chartist);

export default Chartist;



// WEBPACK FOOTER //
// ./javascripts/components/chartist-with-plugins.js